const siteTitle = 'Dokončete objednávku';

export default {
  mainTexts: {
    siteTitle: `${siteTitle}`,
    formTitle1: 'Vyplňte své údaje',
    formTitle2: 'Platíte zde',
    btnForm: 'Pokračovat',
    btnForm2: 'Platit',
    priceText1: 'Způsob platby',
    priceText2: 'Celkový',
    footerTitle: 'Platba přes internet',
    footerText: 'Potvrďte svou kreditní kartou',
  },
  home: {
    placeholder: {
      firstName: 'Jméno',
      lastName: 'Příjmení',
      email: 'Email',
      phone: 'Telefon',
      city: 'Město',
      address: 'Adresa',
      zip: 'ZIP',
      continue: 'Pokračovat',
      name: 'Jméno',
      confirmPayment: 'Potvrďte platbu',
    },
    cardNumber: 'Číslo karty',
    expirationDate: 'Datum spotřeby',
    name: 'Jméno',
    month: 'Měsíc',
    year: 'rok',
    cvv: 'CVV',
    confirmPayment: 'Potvrďte platbu',

    timer: 'Zbývající čas do zaplacení objednávky',
    labelNumber: 'Číslo karty:',
    labelMonth: 'Datum vypršení platnosti:',
    source:
      'K ověření vašeho nákupu používáme 3D zabezpečení. Může se objevit nové okno pro ověření transakce',
  },
  validation: {
    requireEmail: 'Váš email je prázdný.',
    validEmail: 'Email je neplatný.',
    requirePhone: 'Váš telefon je prázdný.',
    minPhone: 'Pole telefon musí mít alespoň 10 znaků.',
    requireFirstName: 'Křestní jméno je povinné.',
    validFirstName: 'Křestní jméno je neplatné',
    requireLastName: 'Pole příjmení je povinné.',
    validLastName: 'Pole příjmení je neplatné',
    requireCity: 'Pole města je povinné.',
    validCity: 'Pole města je neplatné',
    requireAddress: 'Pole adresy je povinné.',
    validAddress: 'Pole adresy je neplatné',
    requireZip: 'Pole zip je povinné.',
    validZip: 'Pole zip je neplatné.',
    requireCard: 'Pole s číslem karty je povinné.',
    minCard: 'Nedostatek symbolů.',
    validCard: 'Pole čísla karty je neplatné.',
    requireMonth: 'Pole měsíce platnosti je povinné.',
    requireYear: 'Pole roku platnosti je povinné.',
    requireName: 'Pole názvu je povinné.',
    validName: 'Pole názvu je neplatné.',
    requireCvv: 'Pole cvv je povinné.',
    validCvv: 'Pole cvv je neplatné.',
    minFirstName: 'Pole jména musí mít alespoň 3 znaky.',
    minLastName: 'Pole příjmení musí mít alespoň 3 znaky.',
    minCity: 'Pole města musí mít alespoň 3 znaky.',
    minAddress: 'Pole adresy musí mít alespoň 3 znaky.',
    minZip: 'Pole PSČ musí mít alespoň 3 znaky.',
    minName: 'Pole názvu musí mít alespoň 3 znaky.',
    minCvv: 'Pole cvv musí mít alespoň 3 znaky.',
    specialFirstName: 'Jméno pole nesmí obsahovat speciální znaky',
    specialLastName: 'Pole příjmení nesmí obsahovat speciální znaky',
    specialName: 'Název pole nesmí obsahovat speciální znaky',
    specialCity: 'Polní město nesmí obsahovat speciální znaky',
  },
  mask: {
    phone: '+420 999 999 999',
    zip: '999 99',
    creditCard: '9999 9999 9999 9999',
    cvv: '9999',
  },
  getInTouch: {
    title: 'BÝT V KONTAKTU',
    firstName: 'Jméno',
    lastName: 'Příjmení',
    email: 'E-mail',
    msg: 'zprávy',
    send: 'Poslat',
    alreadyRegistered: 'už jste se zaregistrovali',
    unsubscribeLink: 'odkaz na odhlášení',
    worktime: 'Call centrum funguje od 10 do 17 hodin',
    phone: 'Telefon: Sofia +359 2 437 4207',
  },
};
